import { isValidNif } from "nif-dni-nie-cif-validation";
import EnumService from "./enum.service";
import UserService from "./user.service";
import gestioneEsitiIncaricoNominatoHook from "../hooks/esitiHooks/esitiIncarico/gestioneEsitiIncaricoNominatoHook";
import { isEsitoInvioOrdinePagamentoOSap } from "../detailTask/bottomBar/pagamentoInviatoSap";

/**
 * Rimuove il prefisso iniziale da una descrizione, se presente.
 * Il prefisso deve essere separato dal resto della descrizione tramite " - ".
 *
 * @param {string} queueDesc - La descrizione originale che potrebbe contenere un prefisso.
 * @returns {string} La descrizione senza il prefisso iniziale. Se non presente, restituisce la stringa originale.
 *
 * @example
 * translateQueueDesc("RE - Descrizione esempio"); // "Descrizione esempio"
 * translateQueueDesc("Descrizione senza prefisso"); // "Descrizione senza prefisso"
 */
 const translateQueueDesc = (queueDesc) => {
  if (!queueDesc) return queueDesc;
  const parts = queueDesc?.split(" - ");
  return parts?.length > 1 ? parts?.slice(1)?.join(" - ") : queueDesc;
};

const translateQueueDescLanguage = (value,currentLanguage) => {
  return UserService.translateCriterioByLanguage(value?.toLowerCase().slice(5),currentLanguage).replace("ISTRUTTORIA", "SINISTRO").replace("INVESTIGACION", "SINIESTRO").replace("CHIUSA", "");
}

const isValidateText = (textToValidate) => {
  let validate = false;
  if (textToValidate?.length >= 2) {
    validate = true;
  }
  return validate
}

const isValidCodiceFiscale = (codiceFiscale) => {
  let validate = false;
  const regex = /^[A-Za-z]{6}[0-9]{2}[A-Za-z][0-9]{2}[A-Za-z][0-9A-Za-z]{3}[A-Za-z]$/;
  if (regex.test(codiceFiscale)) {
    validate = true;
  } else if(isValidNif(codiceFiscale)){
    validate = true
  }
  return validate
}

const isValidPartitaIVA = (piva) => {
  let validate = false;
  const regex = /^[0-9]{11}$/;
  if (regex.test(piva)) {
    validate = true;
  } else if(isValidNif(piva)){
    validate = true
  }
  return validate
}

const isValidPIvaOrCodFiscale = (pivaOrCodFiscale) => {
  let validate = false;
  if(isValidCodiceFiscale(pivaOrCodFiscale)){
    validate = true
  }else if(isValidPartitaIVA(pivaOrCodFiscale)){
    validate = true
  }else if(isValidNif(pivaOrCodFiscale)){
    validate = true
  }
  return validate
}

const isValidPhoneNumber =(input) =>{
  if (!input || typeof input !== "string") return false;

  // Rimuove spazi e trattini
  let number = "";
  for (let i = 0; i < input.length; i++) {
    const char = input[i];
    if (char !== " " && char !== "-") number += char;
  }

  let normalized = number;

  // Caso particolare: "+00..." → converto in "+"
  if (normalized.startsWith("+00")) {
    normalized = `+${  normalized.slice(3)}`;
  }
  // Prefisso internazionale con "00"
  else if (normalized.startsWith("00")) {
    normalized = `+${  normalized.slice(2)}`;
  }

  // Deve iniziare con + oppure con cifra
  if (!(normalized[0] === "+" || (normalized[0] >= "0" && normalized[0] <= "9"))) {
    return false;
  }

  // Controllo caratteri dopo +
  const startIndex = normalized.startsWith("+") ? 1 : 0;
  for (let i = startIndex; i < normalized.length; i++) {
    const c = normalized[i];
    if (c < "0" || c > "9") return false;
  }

  // Conta cifre effettive
  const digitCount = normalized.startsWith("+")
    ? normalized.length - 1
    : normalized.length;

  if (digitCount < 8 || digitCount > 15) {
    return false;
  }

  // Controllo specifico per l’Italia
  if (normalized.startsWith("+39")) {
    const localPart = normalized.slice(3); // tutto dopo +39
    if (!localPart.startsWith("3")) return false;
    if (localPart.length < 9) return false;
  }

  return true;
}

const isValidEmailNew = (email) => {
  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailPattern.test(email);
}



const isNumeric = (value) => {
  return /^-?\d+(\.\d+)?$/.test(value);
}


/**
 * Funzione per validare se un IBAN è italiano
 * @param {String} iban 
 * @returns se l'IBAN è italiano
*/
const isItalianIban = (iban) => {
  if (iban !== undefined && iban !== null && iban !== '') {
    return /^(it|IT)[0-9]{2}[A-Za-z][0-9]{10}[0-9A-Za-z]{12}$/.test(iban);  
  }
  return false;
};


/**
 * Funzione per determinare se un IBAN appartiene al circuito SEPA
 * @param {String} iban 
 * @returns se l'IBAN appartiene al circuito SEPA
*/
const isSepaIban = (iban) => {
  if(iban !== undefined && iban !== null && iban !== '') {
      const sepaCountries = [
        "AT", "AD", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", 
        "FI", "FR", "DE", "GI", "GR", "HU", "IS", "IE", "IT", 
        "LV", "LI", "LT", "LU", "MT", "MC", "NL", "NO", "PL", 
        "PT", "RO", "SM", "SK", "SI", "ES", "SE", "CH", "GB"
      ];
    const countryCode = iban?.slice(0, 2);
    return sepaCountries?.includes(countryCode);
  }
  return false;
};


const gestioneDisableRiserveSoggCoinvonti = (arrValidazioni) => {
  let validate = false;
  const validazioneToCheck = arrValidazioni?.find(item => item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_INDENNIZZO' && item?.statoEsitazione === 'In attesa');
  if (validazioneToCheck){
    validate = true
  }
  return validate
}


const gestionePulsanteIcarichiIstruttoria = (arrValidazioni, riservaSpesa, importoPagamentoSpesa) => {
  if((importoPagamentoSpesa > riservaSpesa)){
    if(arrValidazioni && (arrValidazioni && arrValidazioni?.length > 0)){
      const validazione = arrValidazioni
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_SPESE' &&
          EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );
    
      if(validazione) return !(validazione?.valoreDaAutorizzare >= importoPagamentoSpesa);

      return true;
    }
    return true;
  }
  return false;
}

const gestioneSelectPagSpese = (arrValidazioni, riservaSpesa, importoPagamentoSpesa) => {
  if((importoPagamentoSpesa > riservaSpesa)) {
    if(arrValidazioni && (arrValidazioni && arrValidazioni?.length > 0)){
      const validazione = arrValidazioni
      ?.filter(item =>
        item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_SPESE' &&
        EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
      )
      ?.reduce((max, item) =>
        max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
          ? item
          : max,
        null
      );

      // Creation only needs the reserve approval; payment approval is requested inside the payment task.
      if(validazione)
        return !(validazione?.valoreDaAutorizzare >= importoPagamentoSpesa);

      return true;
    }
    return true;
  }
  return false;
}

const gestioneSuperamentoAuthority = (taskCompletedCheck, riservaIndennizzoToValidate, checkStatoPagamentoIndennizzo, queueDesc, checkStatoSomeDanneggiatoOpen, esitoDescription, taskCompletedCheckSenzaPagamentiLqInd, checkArrayStatoPagamentiInviato, listaPagamentiIndennizzo, checkArrayStatoPagamentiNoInviato, checkArrayStatoPagamentiNotAllOk, checkStatoAllDanneggiati) => {
  //Caso sininistro senza seguito attivo
  if (taskCompletedCheck && (riservaIndennizzoToValidate === 0 /* &&  riservaSpesaCheck === 0 */) && (!checkStatoPagamentoIndennizzo)) {
    if(EnumService.CRITERI.ISTRUTTORIA_CHIUSA.includes(queueDesc?.toLowerCase().slice(5))){
      if(checkStatoSomeDanneggiatoOpen && riservaIndennizzoToValidate > 0){
        return(
          !EnumService.ESITI.SINISTRO_RIAPERTO.includes(esitoDescription.toLowerCase())
        )
      }
      return(
        !EnumService.ESITI.SENZA_SEGUITO.includes(esitoDescription.toLowerCase())
      )
    }
    return (
      EnumService.ESITI.SINISTRO_CHIUSO.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase())  ||
      EnumService.ESITI.SINISTRO_COMPLETATO.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_CHIUSO_TOTALE.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_PARZIALE.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_IN_LAVORAZIONE.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_RIAPERTO.includes(esitoDescription.toLowerCase())
    );
  }
  //Caso sinsistro chiuso Totale
  if (taskCompletedCheckSenzaPagamentiLqInd && (riservaIndennizzoToValidate === 0 /* && riservaSpesaCheck === 0 */) && (checkArrayStatoPagamentiInviato  && listaPagamentiIndennizzo?.length > 0) && checkStatoAllDanneggiati) {
    if(EnumService.CRITERI.ISTRUTTORIA_CHIUSA.includes(queueDesc?.toLowerCase().slice(5))){
      if(checkStatoSomeDanneggiatoOpen && riservaIndennizzoToValidate > 0){
        return(
          !EnumService.ESITI.SINISTRO_RIAPERTO.includes(esitoDescription.toLowerCase())
        )
      }
      return(
        !EnumService.ESITI.SINISTRO_CHIUSO_TOTALE.includes(esitoDescription.toLowerCase())
      )
    }
    return (
      //EnumService.ESITI.SINISTRO_CHIUSO_TOTALE.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase())  ||
      EnumService.ESITI.SENZA_SEGUITO.includes(esitoDescription.toLowerCase()) || 
      EnumService.ESITI.SINISTRO_COMPLETATO.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_PARZIALE.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_IN_LAVORAZIONE.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_RIAPERTO.includes(esitoDescription.toLowerCase())
    );
  }
  //Caso sinsistro chiuso Parziale
  if (taskCompletedCheckSenzaPagamentiLqInd &&  (riservaIndennizzoToValidate > 0 /* && riservaSpesaCheck === 0 */) && (checkArrayStatoPagamentiInviato && listaPagamentiIndennizzo?.length > 0)){
    return (
      EnumService.ESITI.SINISTRO_CHIUSO.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase())   ||
      EnumService.ESITI.SENZA_SEGUITO.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_COMPLETATO.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_CHIUSO_TOTALE.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_IN_LAVORAZIONE.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_RIAPERTO.includes(esitoDescription.toLowerCase())
    );
  }
  //Caso Sinistro Completato
  if(taskCompletedCheck && (riservaIndennizzoToValidate === 0) &&(checkArrayStatoPagamentiNoInviato && checkArrayStatoPagamentiNotAllOk && listaPagamentiIndennizzo?.length > 0)){
    if(EnumService.CRITERI.ISTRUTTORIA_CHIUSA.includes(queueDesc?.toLowerCase().slice(5))){
      if(checkStatoSomeDanneggiatoOpen && riservaIndennizzoToValidate > 0){
        return(
          !EnumService.ESITI.SINISTRO_RIAPERTO.includes(esitoDescription.toLowerCase())
        )
      }
      return (!EnumService.ESITI.SINISTRO_COMPLETATO.includes(esitoDescription.toLowerCase()) &&  !EnumService.ESITI.SINISTRO_CHIUSO_TOTALE.includes(esitoDescription.toLowerCase()))
    }
    return (
      EnumService.ESITI.SINISTRO_CHIUSO.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase())   ||
      EnumService.ESITI.SENZA_SEGUITO.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_CHIUSO_TOTALE.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_PARZIALE.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_IN_LAVORAZIONE.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_RIAPERTO.includes(esitoDescription.toLowerCase())
    )
  }
  //Caso istruttoria chiusa
  if(EnumService.CRITERI.ISTRUTTORIA_CHIUSA.includes(queueDesc?.toLowerCase().slice(5))){
    if(checkStatoSomeDanneggiatoOpen && riservaIndennizzoToValidate > 0){
      return(
        !EnumService.ESITI.SINISTRO_RIAPERTO.includes(esitoDescription.toLowerCase())
      )
    }
    return (!EnumService.ESITI.SINISTRO_COMPLETATO.includes(esitoDescription.toLowerCase()) &&  !EnumService.ESITI.SINISTRO_CHIUSO_TOTALE.includes(esitoDescription.toLowerCase()))
  }
  //Caso danneggiati non tutti chiusi
  if(!checkStatoAllDanneggiati){
    return (
      EnumService.ESITI.SINISTRO_CHIUSO.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase())   ||
      EnumService.ESITI.SENZA_SEGUITO.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_COMPLETATO.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_CHIUSO_TOTALE.includes(esitoDescription.toLowerCase()) ||
      EnumService.ESITI.SINISTRO_PARZIALE.includes(esitoDescription.toLowerCase())
    );
  }

  return (
    !EnumService.ESITI.IN_AGENDA.includes(esitoDescription.toLowerCase()) && 
    !EnumService.ESITI.SINISTRO_IN_LAVORAZIONE.includes(esitoDescription.toLowerCase()) &&
    !EnumService.ESITI.RIASSEGNA_SINISTRO.includes(esitoDescription.toLowerCase())
  )
}

const gestioneSelectPagIndennizzo = (arrValidazioni, riservaIndennizzo, importoPagamentoIndennizzo) => {
  if(importoPagamentoIndennizzo > riservaIndennizzo){

    if(arrValidazioni && (arrValidazioni && arrValidazioni?.length > 0)){
       const validazione = arrValidazioni
      ?.filter(item =>
        item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_INDENNIZZO' &&
        EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
      )
      ?.reduce((max, item) =>
        max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
          ? item
          : max,
        null
      );

      // Creation only needs the reserve approval; payment approval is requested inside the payment task.
      if (validazione){
        return !((validazione?.valoreDaAutorizzare >= importoPagamentoIndennizzo));
      }
      
     return true;
    }
   return true;
  }
  return false;
}

const getDisabledEsitiValueIstruttoriaOld = (riservaIndennizzo, taskCompletedCheck, riservaIndennizzoCheck, riservaSpesaCheck, esito, validazioniIstruttoria, authRiservaSpese, checkStatoPagamentoIndennizzo, listaPagamentiIndennizzo, riservaIndennizzoToValidate, checkStatoAllDanneggiati, taskCompletedCheckSenzaPagamentiLqInd, queueDesc, checkStatoSomeDanneggiatoOpen, checkArrayStatoPagamentiInviato, checkArrayStatoPagamentiNoInviato, checkArrayStatoPagamentiNotAllOk) => {
  const esitoDescription = esito?.description?.toLowerCase();

  // Caso A
  if (riservaIndennizzoCheck > riservaIndennizzo) {
    if (validazioniIstruttoria && validazioniIstruttoria?.length > 0) {
      const validazione = validazioniIstruttoria?.find(elemento => (elemento.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_INDENNIZZO') 
                                                                && (Math.abs(elemento?.valoreDaAutorizzare - riservaIndennizzoCheck) < 1) );
      const validazioneLimitePagamentoIndennizzo = validazioniIstruttoria?.find(elemento => elemento.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_INDENNIZZO');
      const validazioneLimitePagamentoSpese = validazioniIstruttoria?.find(elemento => (elemento.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_SPESE') 
                                                                && (Math.abs(elemento?.valoreDaAutorizzare - riservaSpesaCheck) < 1) );
      
      //Caso Riserva spese
      if(riservaSpesaCheck > authRiservaSpese) {
        if (validazioniIstruttoria && validazioniIstruttoria?.length > 0) {
          const validazioneRiservaSpese = validazioniIstruttoria?.find(elemento => elemento.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_SPESE');
          if(
            validazioneRiservaSpese?.statoEsitazione === ('In attesa') 
            // &&
            // validazioneRiservaSpese?.valoreDaAutorizzare === riservaSpesaCheck
          ){ 
            return(
              !EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase())
            )
          }
          if(
            EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(validazioneRiservaSpese?.statoEsitazione.toLowerCase()) 
            // && 
            // validazioneRiservaSpese?.valoreDaAutorizzare === riservaSpesaCheck
            &&
            (Math.abs(validazioneRiservaSpese?.valoreDaAutorizzare - riservaSpesaCheck) < 1)
          ){
          if(riservaIndennizzoCheck > riservaIndennizzo){
            if(EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(validazione?.statoEsitazione.toLowerCase())
              //  &&
              // validazione?.valoreDaAutorizzare === riservaIndennizzoCheck
              &&
             (Math.abs(validazione?.valoreDaAutorizzare - riservaIndennizzoCheck) < 1)
              ){
              return gestioneSuperamentoAuthority(taskCompletedCheck, riservaIndennizzoToValidate, checkStatoPagamentoIndennizzo, queueDesc, checkStatoSomeDanneggiatoOpen, esitoDescription, taskCompletedCheckSenzaPagamentiLqInd, checkArrayStatoPagamentiInviato, listaPagamentiIndennizzo, checkArrayStatoPagamentiNoInviato, checkArrayStatoPagamentiNotAllOk, checkStatoAllDanneggiati);
            } 
            if(
              validazione?.statoEsitazione === 'In attesa' 
              // &&
              // validazione?.valoreDaAutorizzare === riservaIndennizzoCheck
            ){
              return (
                !EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase()) 
              );
            }
            if(validazioneLimitePagamentoSpese?.statoEsitazione?.toLowerCase() === 'in attesa'){
              return (
                !EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase()) 
              );
            }
            if (EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(validazioneLimitePagamentoSpese?.statoEsitazione.toLowerCase())){
              return gestioneSuperamentoAuthority(taskCompletedCheck, riservaIndennizzoToValidate, checkStatoPagamentoIndennizzo, queueDesc, checkStatoSomeDanneggiatoOpen, esitoDescription, taskCompletedCheckSenzaPagamentiLqInd, checkArrayStatoPagamentiInviato, listaPagamentiIndennizzo, checkArrayStatoPagamentiNoInviato, checkArrayStatoPagamentiNotAllOk, checkStatoAllDanneggiati);
            }
          }
            return false
          }
          return true
        }
        return true
      }
      //caso riserva indennizzo
      if (
        validazione?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_INDENNIZZO' &&
        EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(validazione?.statoEsitazione.toLowerCase())
        &&
        (Math.abs(validazione?.valoreDaAutorizzare - riservaIndennizzoCheck) < 1)
      ) {
        //Caso sininistro senza seguito attivo
        return gestioneSuperamentoAuthority(taskCompletedCheck, riservaIndennizzoToValidate, checkStatoPagamentoIndennizzo, queueDesc, checkStatoSomeDanneggiatoOpen, esitoDescription, taskCompletedCheckSenzaPagamentiLqInd, checkArrayStatoPagamentiInviato, listaPagamentiIndennizzo, checkArrayStatoPagamentiNoInviato, checkArrayStatoPagamentiNotAllOk, checkStatoAllDanneggiati);
      }
      if (
        validazione?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_INDENNIZZO' &&
        validazione?.statoEsitazione === 'In attesa'
      ) {
        return (!EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase()) );
      }
      if(validazioneLimitePagamentoIndennizzo?.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_INDENNIZZO' &&
        EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(validazioneLimitePagamentoIndennizzo?.statoEsitazione.toLowerCase())
        ) {
        return gestioneSuperamentoAuthority(taskCompletedCheck, riservaIndennizzoToValidate, checkStatoPagamentoIndennizzo, queueDesc, checkStatoSomeDanneggiatoOpen, esitoDescription, taskCompletedCheckSenzaPagamentiLqInd, checkArrayStatoPagamentiInviato, listaPagamentiIndennizzo, checkArrayStatoPagamentiNoInviato, checkArrayStatoPagamentiNotAllOk, checkStatoAllDanneggiati);
      }
      if(validazioneLimitePagamentoIndennizzo?.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_INDENNIZZO' &&
          validazioneLimitePagamentoIndennizzo?.statoEsitazione === ('In attesa')
      ) {
        return(
          !EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase())
        )
      }
    } 
    return true;
  }
  //Caso Riserva spese
  if(riservaSpesaCheck > authRiservaSpese) {
    if (validazioniIstruttoria && validazioniIstruttoria?.length > 0) {
      const validazioneRiservaSpese = validazioniIstruttoria?.find(elemento => elemento.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_SPESE');
      const validazioneLimitePagamentoSpese = validazioniIstruttoria?.find(elemento => (elemento.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_SPESE') 
                                                                && (Math.abs(elemento?.valoreDaAutorizzare - riservaSpesaCheck) < 1) );
      if(
        validazioneRiservaSpese?.statoEsitazione === ('In attesa') 
        // &&
        // validazioneRiservaSpese?.valoreDaAutorizzare === riservaSpesaCheck
      ){
        return(
          !EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase())
        )
      }
      if(EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(validazioneRiservaSpese?.statoEsitazione.toLowerCase())
        // && 
        // validazioneRiservaSpese?.valoreDaAutorizzare === riservaSpesaCheck
        &&
         (Math.abs(validazioneRiservaSpese?.valoreDaAutorizzare - riservaSpesaCheck) < 1)
      ){
        return gestioneSuperamentoAuthority(taskCompletedCheck, riservaIndennizzoToValidate, checkStatoPagamentoIndennizzo, queueDesc, checkStatoSomeDanneggiatoOpen, esitoDescription, taskCompletedCheckSenzaPagamentiLqInd, checkArrayStatoPagamentiInviato, listaPagamentiIndennizzo, checkArrayStatoPagamentiNoInviato, checkArrayStatoPagamentiNotAllOk, checkStatoAllDanneggiati);
      }
      if(validazioneLimitePagamentoSpese?.statoEsitazione?.toLowerCase() === 'in attesa'){
        return (
          !EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase()) 
        );
      }
      if (EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(validazioneLimitePagamentoSpese?.statoEsitazione.toLowerCase())){
        return gestioneSuperamentoAuthority(taskCompletedCheck, riservaIndennizzoToValidate, checkStatoPagamentoIndennizzo, queueDesc, checkStatoSomeDanneggiatoOpen, esitoDescription, taskCompletedCheckSenzaPagamentiLqInd, checkArrayStatoPagamentiInviato, listaPagamentiIndennizzo, checkArrayStatoPagamentiNoInviato, checkArrayStatoPagamentiNotAllOk, checkStatoAllDanneggiati);
      }
    }
    return true
  }
  return gestioneSuperamentoAuthority(taskCompletedCheck, riservaIndennizzoToValidate, checkStatoPagamentoIndennizzo, queueDesc, checkStatoSomeDanneggiatoOpen, esitoDescription, taskCompletedCheckSenzaPagamentiLqInd, checkArrayStatoPagamentiInviato, listaPagamentiIndennizzo, checkArrayStatoPagamentiNoInviato, checkArrayStatoPagamentiNotAllOk, checkStatoAllDanneggiati);
}

const getDisabledEsitiValueIstruttoria = (riservaIndennizzo, taskCompletedCheck, riservaIndennizzoCheck, riservaSpesaCheck, esito, validazioniIstruttoria, authRiservaSpese, checkStatoPagamentoIndennizzo, listaPagamentiIndennizzo, riservaIndennizzoToValidate, checkStatoAllDanneggiati, taskCompletedCheckSenzaPagamentiLqInd, queueDesc, checkStatoSomeDanneggiatoOpen, checkArrayStatoPagamentiInviato, checkArrayStatoPagamentiNoInviato, checkArrayStatoPagamentiNotAllOk) => {
    const esitoDescription = esito?.description?.toLowerCase();

    const validazioneLimiteRiservatoIndennizzoApprovato = validazioniIstruttoria
      ?.filter(item =>
        item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_INDENNIZZO' &&
        EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
      )
      ?.reduce((max, item) =>
        max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
          ? item
          : max,
        null
      );
      
    const validazioneLimiteRiservatoIndennizzoInAttesa = validazioniIstruttoria
      ?.filter(item =>
        item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_INDENNIZZO' &&
        EnumService.ESITI.IN_ATTESA.includes(item?.statoEsitazione.toLowerCase())
      )
      ?.reduce((max, item) =>
        max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
          ? item
          : max,
        null
      );

    const validazioneLimitePagamentoIndennizzoInAttesa = validazioniIstruttoria
      ?.filter(item =>
        item?.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_INDENNIZZO' &&
        EnumService.ESITI.IN_ATTESA.includes(item?.statoEsitazione.toLowerCase())
      )
      ?.reduce((max, item) =>
        max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
          ? item
          : max,
        null
      );

    const validazioneLimiteRiservatoSpeseApprovato = validazioniIstruttoria
      ?.filter(item =>
        item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_SPESE' &&
        EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
      )
      ?.reduce((max, item) =>
        max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
          ? item
          : max,
        null
      );

    const validazioneLimiteRiservatoSpeseInAttesa = validazioniIstruttoria
      ?.filter(item =>
        item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_SPESE' &&
        EnumService.ESITI.IN_ATTESA.includes(item?.statoEsitazione.toLowerCase())
      )
      ?.reduce((max, item) =>
        max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
          ? item
          : max,
        null
      );

    const validazioneLimitePagamentoSpeseInAttesa = validazioniIstruttoria
      ?.filter(item =>
        item?.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_SPESE' &&
        EnumService.ESITI.IN_ATTESA.includes(item?.statoEsitazione.toLowerCase())
      )
      ?.reduce((max, item) =>
        max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
          ? item
          : max,
        null
      );
  
      if (validazioneLimitePagamentoIndennizzoInAttesa || validazioneLimiteRiservatoIndennizzoInAttesa || validazioneLimitePagamentoSpeseInAttesa || validazioneLimiteRiservatoSpeseInAttesa){
        return(
          !EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase())
        )
      }

      if (riservaIndennizzoCheck > riservaIndennizzo) {
        if (!(validazioneLimiteRiservatoIndennizzoApprovato && (validazioneLimiteRiservatoIndennizzoApprovato?.valoreDaAutorizzare >= riservaIndennizzoCheck))) {
          return true;
        }
      }

      if(riservaSpesaCheck > authRiservaSpese) {
        if (!(validazioneLimiteRiservatoSpeseApprovato && (validazioneLimiteRiservatoSpeseApprovato?.valoreDaAutorizzare >= riservaSpesaCheck))) {
          return true;
        }
      }
  
  return gestioneSuperamentoAuthority(taskCompletedCheck, riservaIndennizzoToValidate, checkStatoPagamentoIndennizzo, queueDesc, checkStatoSomeDanneggiatoOpen, esitoDescription, taskCompletedCheckSenzaPagamentiLqInd, checkArrayStatoPagamentiInviato, listaPagamentiIndennizzo, checkArrayStatoPagamentiNoInviato, checkArrayStatoPagamentiNotAllOk, checkStatoAllDanneggiati);
}

const checkDisabledPulIstruttAfterValidation = (validazioniIstruttoria, riservaIndennizzoCheck, riservaIndennizzo) => {
  if(riservaIndennizzoCheck > riservaIndennizzo){

      if(validazioniIstruttoria && (validazioniIstruttoria && validazioniIstruttoria?.length > 0)){
        const validazione = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_INDENNIZZO' &&
          EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );

        const validazioneInAttesa = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_INDENNIZZO' &&
          EnumService.ESITI.IN_ATTESA.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );

        if (validazione || validazioneInAttesa){
            return !((validazione?.valoreDaAutorizzare >= riservaIndennizzoCheck) || (validazioneInAttesa?.valoreDaAutorizzare >= riservaIndennizzoCheck));
        }
      return true;
      }
    return true;
   }
   return false;
};

const gestioneEsitiQuitenza = (esito, riservaIndennizzoEur, riservaIndennizzo, listaValidazioni) => {
 if(riservaIndennizzoEur > riservaIndennizzo){
    if(listaValidazioni && (listaValidazioni && listaValidazioni?.length > 0)){
       const validazione = listaValidazioni
      ?.filter(item =>
        item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_INDENNIZZO' &&
        EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
      )
      ?.reduce((max, item) =>
        max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
          ? item
          : max,
        null
      );

       if (validazione && (validazione && (validazione?.valoreDaAutorizzare >= riservaIndennizzoEur))){
          return EnumService.ESITI.IN_VALIDAZIONE.includes(esito.description.toLowerCase()) 
        }

     const validazioneInAttesa = listaValidazioni
      ?.filter(item =>
        item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_INDENNIZZO' &&
        EnumService.ESITI.IN_ATTESA.includes(item?.statoEsitazione.toLowerCase())
      )
      ?.reduce((max, item) =>
        max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
          ? item
          : max,
        null
      );
      
      if (validazioneInAttesa && (validazioneInAttesa && (validazioneInAttesa?.valoreDaAutorizzare >= riservaIndennizzoEur))){
          return( 
          EnumService.ESITI.IN_AGENDA.includes(esito.description.toLowerCase()) ||
          EnumService.ESITI.QUIETANZA_EMESSA.includes(esito?.description.toLowerCase())
        )
      } 
      
     return true;
    }
   return true;
  }
  return EnumService.ESITI.IN_VALIDAZIONE.includes(esito.description.toLowerCase())  
}

const disabledPulsantiQuietanza = (riservaIndennizzoEur, riservaIndennizzo, listaValidazioni) => {
 if(riservaIndennizzoEur > riservaIndennizzo){

      if(listaValidazioni && (listaValidazioni && listaValidazioni?.length > 0)){
        const validazione = listaValidazioni
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_INDENNIZZO' &&
          EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );

        if (validazione){
            return !((validazione?.valoreDaAutorizzare >= riservaIndennizzoEur));
        }
        return true;
      }
    return true;
   }
  return false;
}

const gestioneDisabledEsitiPagIndennizzo = (validazioniIstruttoria, esito, riservaIndennizzo, importoPagamento, pagamentoId,isInstantPaymentAvailable ) => {
  const esitoDescription = esito.description.toLowerCase();
  if(importoPagamento > riservaIndennizzo){
    if(validazioniIstruttoria && (validazioniIstruttoria && validazioniIstruttoria?.length > 0)){
      
      const validazione = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_INDENNIZZO' &&
          EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );
      
      if (validazione)
      {
        return EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase()) 
      }
      
      const validazioneInAttesa = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_INDENNIZZO' &&
          EnumService.ESITI.IN_ATTESA.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );

      if (validazioneInAttesa){
          return (
            !EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription) 
          );
      }

      return  (!EnumService.ESITI.IN_AGENDA.includes(esitoDescription.toLowerCase()) && !EnumService.ESITI.PAGAMENTO_INDENNIZZO_NON_ACCETTATO.includes(esitoDescription.toLowerCase())); 
    }
    return (!EnumService.ESITI.IN_AGENDA.includes(esitoDescription.toLowerCase()) && !EnumService.ESITI.PAGAMENTO_INDENNIZZO_NON_ACCETTATO.includes(esitoDescription.toLowerCase()));
  }
  if (
    EnumService.ESITI.PAGAMENTO_ISTANTANEO.includes(esitoDescription) &&
    importoPagamento > 0 &&
    pagamentoId && 
    !isInstantPaymentAvailable === false
  ) {
    return !isEsitoInvioOrdinePagamentoOSap(esitoDescription)
  }
  if (
    isEsitoInvioOrdinePagamentoOSap(esitoDescription) &&
    importoPagamento > 0 &&
    pagamentoId && 
    isInstantPaymentAvailable
  ) {
    return !isEsitoInvioOrdinePagamentoOSap(esitoDescription);
  }
  return EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase())
}

const gestioneAlertValidazionePagIndennizzo = (validazioniIstruttoria, riservaIndennizzo, pagamentoId, importoPagamento) => {
  if(importoPagamento > riservaIndennizzo){
     if(validazioniIstruttoria && (validazioniIstruttoria && validazioniIstruttoria?.length > 0)){

        const validazione = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_INDENNIZZO' &&
          EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );

        const validazioneInAttesa = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_INDENNIZZO' &&
          EnumService.ESITI.IN_ATTESA.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );
    
        if(validazione || validazioneInAttesa) 
          return !((validazione?.valoreDaAutorizzare >= importoPagamento) || (validazioneInAttesa?.valoreDaAutorizzare >= importoPagamento) );
        return true;
     }
    return true;
  }
  return false;
}

const gestionePulsantiPagIndennizzo = (validazioniIstruttoria, riservaIndennizzo, importoPagamento) => {
  if(importoPagamento > riservaIndennizzo){
     if(validazioniIstruttoria && (validazioniIstruttoria && validazioniIstruttoria?.length > 0)){

        const validazione = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_INDENNIZZO' &&
          EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );
    
        if(validazione) return !(validazione?.valoreDaAutorizzare >= importoPagamento);
        return true;
     }
    return true;
  }
  return false;
}

const gestioneEsitiPagSpese = (validazioniIstruttoria, esito, riservaSpesa, importoPagamentoSpesa, isInstantPaymentAvailable) => {
  const esitoDescription = esito.description.toLowerCase();
  if(importoPagamentoSpesa > riservaSpesa){
     if(validazioniIstruttoria && (validazioniIstruttoria && validazioniIstruttoria?.length > 0)){

      const validazione = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_SPESE' &&
          EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );

        if((validazione) && (validazione?.valoreDaAutorizzare >= importoPagamentoSpesa)){
          return  EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase());
        }

        const validazioneInAttesa = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_SPESE' &&
          EnumService.ESITI.IN_ATTESA.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );

        if (validazioneInAttesa){
          return (
              !EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase()) 
          );
        }
    }
    return true
  }
  if (
    EnumService.ESITI.PAGAMENTO_ISTANTANEO.includes(esitoDescription) &&
    importoPagamentoSpesa > 0 &&
    !isInstantPaymentAvailable === false
  ) {
    return !isEsitoInvioOrdinePagamentoOSap(esitoDescription)
  }
  if (
    isEsitoInvioOrdinePagamentoOSap(esitoDescription) &&
    importoPagamentoSpesa > 0 &&
    isInstantPaymentAvailable
  ) {
    return !isEsitoInvioOrdinePagamentoOSap(esitoDescription);
  }
  return EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription.toLowerCase()) 
}

const gestioneAlertvalidazionePagSpese = (validazioniIstruttoria, riservaSpesa, importoPagamentoSpesa) => {
  if(importoPagamentoSpesa > riservaSpesa) {
   if(validazioniIstruttoria && (validazioniIstruttoria && validazioniIstruttoria?.length > 0)){
        const validazione = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_SPESE' &&
          EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );

        const validazioneInAttesa = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_PAGAMENTO_SPESE' &&
          EnumService.ESITI.IN_ATTESA.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );
    
        if(validazione || validazioneInAttesa) 
          return !((validazione?.valoreDaAutorizzare >= importoPagamentoSpesa) || (validazioneInAttesa?.valoreDaAutorizzare >= importoPagamentoSpesa));
        return true;
    }
    return true;
  }
  return false
}

const gestioneEsitiIncarichi = (authRiservaSpese,  validazioniIstruttoria, esito,riservaSpeseComplessive, importoRiservaSingolo, listaPagamentiSpesaPerIncarico, importoTotalePagamentiSpesaPerIncarico, rispervaSpesaIncarico, criterioIncaricoNominato, statoIncarico) => {
  const esitoDescription = esito.description.toLowerCase();
  if(Number(importoRiservaSingolo) > 0) {
    if(riservaSpeseComplessive > authRiservaSpese) {
     if(validazioniIstruttoria && (validazioniIstruttoria && validazioniIstruttoria?.length > 0)){
       /* const validazione = validazioniIstruttoria?.find(elemento => elemento.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_SPESE'
                                                        && (Math.abs(elemento?.valoreDaAutorizzare - riservaSpeseComplessive) < 1));*/
         
      const validazione = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_SPESE' &&
          EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );
    
        if((validazione) && (validazione?.valoreDaAutorizzare >= riservaSpeseComplessive)){
          return gestioneEsitiIncaricoNominatoHook(esito, listaPagamentiSpesaPerIncarico, importoTotalePagamentiSpesaPerIncarico, rispervaSpesaIncarico, criterioIncaricoNominato, statoIncarico);
        }

        const validazioneInAttesa = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_SPESE' &&
          EnumService.ESITI.IN_ATTESA.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );

        if (validazioneInAttesa){
          return (
            !EnumService.ESITI.IN_VALIDAZIONE.includes(esitoDescription) 
          );
        }
      }
      return true
    }
    return gestioneEsitiIncaricoNominatoHook(esito, listaPagamentiSpesaPerIncarico, importoTotalePagamentiSpesaPerIncarico, rispervaSpesaIncarico, criterioIncaricoNominato, statoIncarico)
  }
  return  gestioneEsitiIncaricoNominatoHook(esito, listaPagamentiSpesaPerIncarico, importoTotalePagamentiSpesaPerIncarico, rispervaSpesaIncarico, criterioIncaricoNominato, statoIncarico)
}

const gestioneAlertValidazioneRiservaSpeseIncIstr = (authRiservaSpese, importoRiserva, validazioniIstruttoria) => {
  if(importoRiserva > authRiservaSpese) {
   if(validazioniIstruttoria && (validazioniIstruttoria && validazioniIstruttoria?.length > 0)){

        const validazione = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_SPESE' &&
          EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );
    
        const validazioneInAttesa = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_SPESE' &&
          EnumService.ESITI.IN_ATTESA.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );

        if(validazione || validazioneInAttesa) 
          return !((validazione?.valoreDaAutorizzare >= importoRiserva) || (validazioneInAttesa?.valoreDaAutorizzare >= importoRiserva));
        return true;
    }
    return true;
  }
  return false;
}

const gestioneAlertValidazioneRiservaSpeseInc = (authRiservaSpese, validazioniIstruttoria, riservaSpeseComplessive, importoRiservaSingolo) => {
  if(Number(importoRiservaSingolo) > 0) {
    if(riservaSpeseComplessive > authRiservaSpese) {
      if(validazioniIstruttoria && (validazioniIstruttoria && validazioniIstruttoria?.length > 0)){

        const validazione = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_SPESE' &&
          EnumService.ESITI.SUPERAMENTO_AUTHORITY_APPROVATO.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );

        const validazioneInAttesa = validazioniIstruttoria
        ?.filter(item =>
          item?.tipoValidazione === 'VALIDAZIONE_LIMITE_RISERVATO_SPESE' &&
          EnumService.ESITI.IN_ATTESA.includes(item?.statoEsitazione.toLowerCase())
        )
        ?.reduce((max, item) =>
          max == null || item.valoreDaAutorizzare > max.valoreDaAutorizzare
            ? item
            : max,
          null
        );

        if(validazione || validazioneInAttesa) 
          return !((validazione?.valoreDaAutorizzare >= riservaSpeseComplessive) || (validazioneInAttesa?.valoreDaAutorizzare >= riservaSpeseComplessive));
        return true;
         
      }
      return true;
    }
  }
  return false;
}

const gestioneEsitiMarineDenuncia = (esito, numeroPolizza, riservaIndennizzoCheck, riservaIndennizzo) => {
  const esitoDescription = esito.description.toLowerCase()
  if(numeroPolizza === '' || numeroPolizza === null || numeroPolizza?.toLowerCase() === 'non specificato' || numeroPolizza?.toLowerCase() === 'null'){
    return EnumService.ESITI.SINISTRO_APERTO.includes(esitoDescription.toLowerCase())
  }
  if(riservaIndennizzoCheck < riservaIndennizzo){
    return true
  }
  return EnumService.ESITI.SHELL_CLAIM.includes(esitoDescription.toLowerCase())
}

const gestioneEsitiShellClaim = (esito, numeroPolizza) => {
  const esitoDescription = esito.description.toLowerCase()
  if(numeroPolizza === '' || numeroPolizza === null || numeroPolizza?.toLowerCase() === 'non specificato' || numeroPolizza?.toLowerCase() === 'null'){
    return EnumService.ESITI.SINISTRO_APERTO_DA_SHELL_CLAIM.includes(esitoDescription.toLowerCase())
  }
  return false
}

const profileValidation = {
  translateQueueDesc,translateQueueDescLanguage,
  isValidateText,
  isValidCodiceFiscale,
  isValidPartitaIVA,
  isValidPhoneNumber,
  isNumeric,
  isValidEmailNew,
  isItalianIban,
  isSepaIban,
  isValidPIvaOrCodFiscale,
  //validazioneDisabledPulsantiIstruttoria,
  getDisabledEsitiValueIstruttoria,
  getDisabledEsitiValueIstruttoriaOld,
  checkDisabledPulIstruttAfterValidation,
  gestioneDisabledEsitiPagIndennizzo,
  gestioneAlertValidazionePagIndennizzo,
  gestionePulsantiPagIndennizzo,
  gestioneDisableRiserveSoggCoinvonti,
  gestioneEsitiIncarichi,
  gestioneAlertValidazioneRiservaSpeseIncIstr,
  gestioneAlertValidazioneRiservaSpeseInc,
  gestioneEsitiPagSpese,
  gestioneAlertvalidazionePagSpese,
  gestionePulsanteIcarichiIstruttoria,
  gestioneSelectPagIndennizzo,
  gestioneSelectPagSpese,
  gestioneEsitiMarineDenuncia,
  gestioneEsitiShellClaim,
  gestioneEsitiQuitenza,
  disabledPulsantiQuietanza
};

export default profileValidation;
